import { AloDbBase, IAloDbBaseConstParam } from '@/models/alodb/AloDbBase'
import { AloBaseArray } from '@/models/alo/AloBaseArray'

export interface IAloDbUmbTypeConstParam extends IAloDbBaseConstParam {
    UMT_ID:number|null
    UMC_ID:number|null
    UMT_KEY:string|null
    UMT_LIBELLE:string|null    
    UMT_FABRICANT:string|null
    UMT_INTEGRATEUR:string|null
    UMT_MAX_PRESS:number|null
    UMT_MOY_CONSO:number|null
  }

export class AloDbUmbType extends AloDbBase {
        
    public UMT_ID:number|null
    public UMC_ID:number|null
    public UMT_KEY:string|null  
    public UMT_LIBELLE:string|null
    public UMT_FABRICANT:string|null
    public UMT_INTEGRATEUR:string|null
    public UMT_MAX_PRESS:number|null
    public UMT_MOY_CONSO:number|null
    
    constructor({UMT_ID,UMC_ID,UMT_KEY,UMT_LIBELLE,UMT_FABRICANT,UMT_INTEGRATEUR,UMT_MAX_PRESS,UMT_MOY_CONSO,...args }:IAloDbUmbTypeConstParam = {} as IAloDbUmbTypeConstParam) {
        super(args)
        this.UMT_ID = UMT_ID
        this.UMC_ID = UMC_ID
        this.UMT_KEY = UMT_KEY
        this.UMT_LIBELLE = UMT_LIBELLE        
        this.UMT_FABRICANT = UMT_FABRICANT   
        this.UMT_INTEGRATEUR = UMT_INTEGRATEUR   
        this.UMT_MAX_PRESS = UMT_MAX_PRESS   
        this.UMT_MOY_CONSO = UMT_MOY_CONSO   
    }

    static createAloDbUmbTypeArray(datas:any) {
        return new AloBaseArray(AloDbUmbType,datas)
    }

    static createAloDbUmbTypeWithDetail(data:any) {
        return new AloDbUmbType({...data,detailLoaded:true})
    }
}
